/**
 * @generated SignedSource<<0daab9cb2ae083931ce7288686dee34c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CommentCommentsFragment$data = {
  readonly children: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly hotness: number;
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"CommentFragment">;
      };
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "CommentCommentsFragment";
};
export type CommentCommentsFragment$key = {
  readonly " $data"?: CommentCommentsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentCommentsFragment">;
};

import CommentCommentsFragmentPaginationQuery_graphql from './CommentCommentsFragmentPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "children"
],
v1 = {
  "kind": "Variable",
  "name": "order",
  "variableName": "order"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "bottomLevel"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "level1"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "level2"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "level3"
    },
    {
      "defaultValue": "HOT",
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "topLevel"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": CommentCommentsFragmentPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "CommentCommentsFragment",
  "selections": [
    {
      "alias": "children",
      "args": [
        (v1/*:: as any*/)
      ],
      "concreteType": "CommentConnection",
      "kind": "LinkedField",
      "name": "__CommentCommentsFragment_children_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CommentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hotness",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Comment",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*:: as any*/),
                {
                  "condition": "topLevel",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "level1",
                          "value": true
                        },
                        (v1/*:: as any*/)
                      ],
                      "kind": "FragmentSpread",
                      "name": "CommentFragment"
                    }
                  ]
                },
                {
                  "condition": "level1",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "level2",
                          "value": true
                        },
                        (v1/*:: as any*/)
                      ],
                      "kind": "FragmentSpread",
                      "name": "CommentFragment"
                    }
                  ]
                },
                {
                  "condition": "level2",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "level3",
                          "value": true
                        },
                        (v1/*:: as any*/)
                      ],
                      "kind": "FragmentSpread",
                      "name": "CommentFragment"
                    }
                  ]
                },
                {
                  "condition": "level3",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "bottomLevel",
                          "value": true
                        },
                        (v1/*:: as any*/)
                      ],
                      "kind": "FragmentSpread",
                      "name": "CommentFragment"
                    }
                  ]
                },
                {
                  "condition": "bottomLevel",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "leafLevel",
                          "value": true
                        },
                        (v1/*:: as any*/)
                      ],
                      "kind": "FragmentSpread",
                      "name": "CommentFragment"
                    }
                  ]
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    (v2/*:: as any*/)
  ],
  "type": "Comment",
  "abstractKey": null
};
})();

(node as any).hash = "68425cd2164ca24e691ae35f11d800b3";

export default node;
